module.exports = __webpack_public_path__ + "img/level.e0d4f98d.png";